module.exports = __webpack_public_path__ + "static/media/assessment-icon.6d2641c8.svg";


//////////////////
// WEBPACK FOOTER
// /src/globals/images/assessment-icon.svg
// module id = 1944
// module chunks = 0